<template>
    <input
        :value="value" :disabled="!api.canEdit || api.batchEditing || Boolean(api.hoursArrivalRequirement && api.plannedArrivalModalVisible)" type="text" inputmode="decimal" autocomplete="off" draggable="false"
        class="timesheet-keyboard-cell" :class="{'is-save-pending': state.pending, 'is-save-error': state.error}"
        :data-line-id="line.id" :data-work-date="date" :title="statusTitle"
        :aria-label="`${line.employee_name_snapshot}, ${date}`" :aria-invalid="state.error ? 'true' : null"
        @input="input" @compositionend="input" @focus="api.handleEntryFocus(line, date, $event)"
        @blur="api.handleEntryBlur(line, date)" @change="api.handleMonthCellChange(line, date)"
        @keydown="api.handleCellArrow(line, date, $event)"
        @keydown.enter.prevent="api.handleCellEnter(line, date, $event)"
        @dragstart.prevent @drop.prevent
    >
</template>

<script>
import {isTimesheetValuePrefix} from '@/utils/timesheetValueInput';

export default {
    name: 'TimesheetEntryInput',
    props: {api: {type: Object, required: true}, line: {type: Object, required: true},
        date: {type: String, required: true}, title: {type: String, default: ''}},
    mounted() { this.registerCell(); },
    updated() { this.registerCell(); },
    beforeDestroy() {
        if (this.api._cellPicker) this.api._cellPicker.unregister(this._registeredKey, this.$el);
        // Switching layout can remove a focused control without a native blur event.
        if (!this.api._isBeingDestroyed && this.state.dirty && !this.state.error) this.api.queueCellSave(this.line, this.date);
    },
    computed: {
        key() { return this.api.cellKey(this.line.id, this.date); },
        value() { return this.api.monthCellDrafts[this.key] || ''; },
        state() { return this.api.editStates[this.key] || {}; },
        statusTitle() { return this.api.editStateTitle(this.key) || this.title; }
    },
    methods: {
        registerCell() {
            if (!this.api._cellPicker) return;
            if (this._registeredKey && this._registeredKey !== this.key) this.api._cellPicker.unregister(this._registeredKey, this.$el);
            this.api._cellPicker.register(this.key, this.$el);
            this._registeredKey = this.key;
        },
        input(event) {
            if (event.isComposing) return;
            if (this.api.batchEditing || this.api.hoursArrivalRequirement && this.api.plannedArrivalModalVisible) { event.target.value = this.value; return; }
            this.api.arrivalCancelledMessage = '';
            const bootstrap = this.api.bootstrapData || {};
            if (!isTimesheetValuePrefix(event.target.value, bootstrap.codes || [], (bootstrap.policy || {}).maximum_daily_minutes || 1440)) {
                event.target.value = this.value;
                return;
            }
            this.$set(this.api.monthCellDrafts, this.key, event.target.value);
            this.api.trackCellInput(this.line, this.date);
            if (this.api._cellPicker) this.api._cellPicker.suggestFor(this.line, this.date, event.target, event.target.value);
        }
    }
};
</script>

<style scoped>
.timesheet-keyboard-cell:not(:disabled) { cursor: crosshair; }
.is-save-pending { box-shadow: inset 0 -2px #d18a00 !important; }
.is-save-error { box-shadow: inset 0 0 0 2px #c0392b !important; background: #fff4f1 !important; }
</style>
